export default "__VITE_ASSET__c08f1323__"